import { RemoteDataTrack } from 'twilio-video';

import { RemoteDataDelegator } from '../../../../core/room/participant/media/MediaDelegator';

export class TwilioRemoteDataDelegator implements RemoteDataDelegator {
  readonly kind = 'data' as const;

  #track: RemoteDataTrack;

  constructor(dataTrack: RemoteDataTrack) {
    this.#track = dataTrack;
  }

  get sid() {
    return this.#track.sid;
  }

  get isEnabled() {
    return this.#track.isEnabled;
  }

  on(event: 'message', eventListener: (message: string) => Promise<null | undefined>) {
    this.#track.on(event, eventListener);
  }

  off(event: 'message', eventListener: (message: string) => Promise<null | undefined>) {
    this.#track.off(event, eventListener);
  }
}
